<kt-portlet class="edit-doctor-div">
  <kt-portlet-header
    [title]="getTitle()"
    class="card-head-lg cards-inside-doctor-form"
    [viewLoading$]="loading$"
  >
    <ng-container ktPortletTools>
      <a
        ktBackButton
        class="btn btn-secondary mr-2"
        mat-raised-button
        matTooltip="Back to the Pharmacy Group list"
      >
        <i class="la la-arrow-left"></i>
        <span class="hidden-mobile" translate="GLOBAL.BACK">Back</span>
      </a>
      <ng-template ngxPermissionsOnly="canEditPharmacyGroup">
        <a
          *ngIf="isViewMode"
          (click)="editPharmacyGroup(pharmacyGroup.id)"
          class="btn btn-secondary mr-2"
          mat-raised-button
          matTooltip="Edit Pharmacy Group"
        >
          <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
        </a>
      </ng-template>
      <a
        *ngIf="!isViewMode && pharmacyGroup && !pharmacyGroup.id"
        href="javascript:;"
        class="btn btn-secondary mr-2"
        (click)="reset()"
        [disabled]="selectedTab !== 0"
        mat-raised-button
        matTooltip="Reset changes"
      >
        <i class="la la-cog"></i>
        <span class="hidden-mobile" translate="GLOBAL.RESET">Reset</span>
      </a>
      <a
        *ngIf="!isViewMode"
        href="javascript:;"
        class="btn btn-primary mr-2"
        color="primary"
        (click)="onSumbit(false)"
        mat-raised-button
        matTooltip="Save & Continue"
      >
        <span class="hidden-mobile" translate="GLOBAL.SAVE">Save</span>
      </a>
    </ng-container>
  </kt-portlet-header>
  <mat-tab-group [(selectedIndex)]="selectedTab" *ngIf="pharmacyGroup">
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="mat-tab-label-icon fa fa-info"></i>
        {{ 'AUTH.INPUT.BASIC_INFO' | translate }}
      </ng-template>
      <ng-template matTabContent>
        <div *ngIf="pharmacyGroup">
          <!--begin::Form-->
          <form [formGroup]="pharmacyGroupForm" class="form form-group-seperator-dashed">
            <kt-alert
              *ngIf="hasFormErrors"
              type="warn"
              [showCloseButton]="true"
              [duration]="10000"
              (closeAl)="onAlertClose()"
            >
              <span translate="GLOBAL.FORM_ERROR"
                >Oh snap! Change a few things up and try submitting again.</span
              >
            </kt-alert>

            <div class="form-section form-section-first whole-form">
              <div class="form-group row cards-inside-doctor-form">
                <div class="col-lg-12 card-header-doctor-form">
                  <h4 translate="PHARMACY_GROUP.FORM.BASIC_INFO">Basic Info</h4>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="PHARMACY_GROUP.FORM.NAME">Name</mat-label>
                    <input matInput formControlName="name" required />
                    <mat-error>
                      Name is
                      <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="PHARMACY_GROUP.FORM.EMAIL">Email</mat-label>
                    <input matInput type="email" formControlName="email" />
                    <mat-error *ngIf="isControlHasError('email', 'pattern')">
                      Email is not valid
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label>Preferred Communication </mat-label>
                    <mat-select formControlName="preferred_communication_method">
                      <mat-option value="EMAIL">{{
                        'PHARMACY_GROUP.FORM.EMAIL' | translate
                      }}</mat-option>
                      <mat-option value="FAX">{{
                        'PHARMACY_GROUP.FORM.FAX' | translate
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-lg-3 kt-margin-bottom-20-mobile">
                  <div class="mat-form-field-fluid">
                    <mat-label
                      class="row ml-1"
                      translate="PHARMACY_GROUP.FORM.PHARMACY_GROUP_STATUS"
                      >PharmacyGroup Status
                    </mat-label>
                    <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
                    <mat-hint align="start">
                      <strong>{{ getStatusString() }}</strong>
                    </mat-hint>
                  </div>
                </div>
              </div>
              <div class="form-group row cards-inside-doctor-form">
                <div class="col-lg-12 card-header-doctor-form">
                  <h4>Contacts</h4>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="PHARMACY_GROUP.FORM.PHONE">Phone</mat-label>
                    <input
                      matInput
                      type="tel"
                      formControlName="phone"
                      maxlength="14"
                      ktAppPhoneMask
                    />
                    <mat-error *ngIf="isControlHasError('phone', 'pattern')">
                      Phone is invalid
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="PHARMACY_GROUP.FORM.FAX">Fax</mat-label>
                    <input
                      matInput
                      type="tel"
                      formControlName="fax"
                      maxlength="14"
                      ktAppPhoneMask
                    />
                    <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                      Fax is invalid
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="form-group row cards-inside-doctor-form">
                <div class="col-lg-12 card-header-doctor-form">
                  <h4>Address</h4>
                </div>
                <div class="col-lg-12 kt-margin-bottom-20-mobile">
                  <mat-form-field class="mat-form-field-fluid" appearance="fill">
                    <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                    <input
                      matInput
                      formControlName="urbanization"
                      [ngModel]="urbanizationValue"
                      (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                    />
                    <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                      Maximum length is 48 character
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-12 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                    <input
                      matInput
                      formControlName="address1"
                      [ngModel]="Address1Value"
                      (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                      required
                    />
                    <mat-error *ngIf="isControlHasError('address1', 'maxlength')">
                      Maximum length is 48 character
                    </mat-error>
                    <mat-error *ngIf="isControlHasError('address1', 'required')">
                      Address1 is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-12 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                    <input
                      matInput
                      formControlName="address2"
                      [ngModel]="Address2Value"
                      (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                    />
                    <mat-error *ngIf="isControlHasError('address2', 'maxlength')">
                      Maximum length is 48 character
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                    <input
                      matInput
                      formControlName="city"
                      [ngModel]="cityValue"
                      (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                      required
                    />
                    <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                      Maximum length is 30 character
                    </mat-error>
                    <mat-error *ngIf="isControlHasError('city', 'required')">
                      City is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                    <mat-select formControlName="state" required>
                      <mat-option value="AL">AL</mat-option>
                      <mat-option value="AK">AK</mat-option>
                      <mat-option value="AR">AR</mat-option>
                      <mat-option value="AZ">AZ</mat-option>
                      <mat-option value="CA">CA</mat-option>
                      <mat-option value="CO">CO</mat-option>
                      <mat-option value="CT">CT</mat-option>
                      <mat-option value="DC">DC</mat-option>
                      <mat-option value="DE">DE</mat-option>
                      <mat-option value="FL">FL</mat-option>
                      <mat-option value="GA">GA</mat-option>
                      <mat-option value="HI">HI</mat-option>
                      <mat-option value="IA">IA</mat-option>
                      <mat-option value="ID">ID</mat-option>
                      <mat-option value="IL">IL</mat-option>
                      <mat-option value="IN">IN</mat-option>
                      <mat-option value="KS">KS</mat-option>
                      <mat-option value="KY">KY</mat-option>
                      <mat-option value="LA">LA</mat-option>
                      <mat-option value="MA">MA</mat-option>
                      <mat-option value="MD">MD</mat-option>
                      <mat-option value="ME">ME</mat-option>
                      <mat-option value="MI">MI</mat-option>
                      <mat-option value="MN">MN</mat-option>
                      <mat-option value="MO">MO</mat-option>
                      <mat-option value="MS">MS</mat-option>
                      <mat-option value="MT">MT</mat-option>
                      <mat-option value="NC">NC</mat-option>
                      <mat-option value="NE">NE</mat-option>
                      <mat-option value="NH">NH</mat-option>
                      <mat-option value="NJ">NJ</mat-option>
                      <mat-option value="NM">NM</mat-option>
                      <mat-option value="NV">NV</mat-option>
                      <mat-option value="NY">NY</mat-option>
                      <mat-option value="ND">ND</mat-option>
                      <mat-option value="OH">OH</mat-option>
                      <mat-option value="OK">OK</mat-option>
                      <mat-option value="OR">OR</mat-option>
                      <mat-option value="PA">PA</mat-option>
                      <mat-option value="PR">PR</mat-option>
                      <mat-option value="RI">RI</mat-option>
                      <mat-option value="SC">SC</mat-option>
                      <mat-option value="SD">SD</mat-option>
                      <mat-option value="TN">TN</mat-option>
                      <mat-option value="TX">TX</mat-option>
                      <mat-option value="UT">UT</mat-option>
                      <mat-option value="VT">VT</mat-option>
                      <mat-option value="VA">VA</mat-option>
                      <mat-option value="WA">WA</mat-option>
                      <mat-option value="WI">WI</mat-option>
                      <mat-option value="WV">WV</mat-option>
                      <mat-option value="WY">WY</mat-option>
                    </mat-select>
                    <mat-error *ngIf="isControlHasError('state', 'required')">
                      State is required
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                    <input
                      matInput
                      formControlName="zip"
                      maxlength="10"
                      [ngModel]="zipValue"
                      (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                      required
                    />
                    <mat-error *ngIf="isControlHasError('zip', 'required')">
                      Zip Code is required
                    </mat-error>
                    <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                      Zip Code is invalid
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="form-group row cards-inside-doctor-form">
                <div class="col-lg-12 card-header-doctor-form">
                  <h4 translate="PHARMACY_GROUP.FORM.OTHER">Other</h4>
                </div>
                <div class="col-lg-12 kt-margin-bottom-20-mobile">
                  <mat-form-field appearance="fill" class="mat-form-field-fluid">
                    <mat-label translate="PHARMACY_GROUP.FORM.NOTE">Note</mat-label>
                    <textarea matInput rows="7" formControlName="note"></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!--end::Form-->
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="pharmacyGroup && pharmacyGroup.id">
      <ng-template mat-tab-label>
        <i class="mat-tab-label-icon fas fa-pills"></i>
        Drugs
      </ng-template>
      <ng-template matTabContent>
        <div class="until-they">
          <kt-pharmacy-group-drugs-list
            [pharmacyGroupId$]="pharmacyGroupId$"
            [isViewMode$]="isViewMode$"
          ></kt-pharmacy-group-drugs-list>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</kt-portlet>

